// extracted by mini-css-extract-plugin
export default {"bodyItem":"BodyItem_bodyItem__1XUQC"};